// Pure helpers for the global inline-calculator overlay — extracted from
// CalculatorOverlay.jsx for readability.

const ALLOWED = /^[0-9+\-*/.() \t]+$/;

export function evaluateExpression(raw) {
  if (!raw) return null;
  const clean = String(raw).trim();
  if (!clean) return null;
  if (!ALLOWED.test(clean)) return null;
  try {
    const val = new Function(`return (${clean})`)();
    if (typeof val !== "number" || !Number.isFinite(val)) return null;
    return Math.round(val * 100) / 100;
  } catch {
    return null;
  }
}

export function isEligibleCalcInput(el) {
  if (!el || el.disabled || el.readOnly) return false;
  if (el.tagName !== "INPUT") return false;
  if (el.dataset && el.dataset.noCalc === "1") return false;
  const t = (el.type || "").toLowerCase();
  return t === "number" || t === "text" || t === "";
}

// A "money-ish" input is: type=number, opts-in via data-calc=1, or any
// text-like input whose value/placeholder/name/testid hints at money.
// Explicit opt-out via data-calc="0".
const NUMLIKE = /^-?[\d,]*\.?\d*$/;
const MONEY_HINT = /(amount|amt|cash|total|balance|deposit|fee|price|cost|sales|tax|rate|value|charge|paid|receiv|expens|purchas|tip|credit|debit|due|sold|earn|owed|money)/i;

export function isMoneyCalcInput(el) {
  if (el.type === "number") return true;
  if (el.dataset && el.dataset.calc === "1") return true;
  if (el.dataset && el.dataset.calc === "0") return false;
  if (el.type !== "text" && el.type !== "") return false;
  // Text input: accept if value is numeric-like OR if metadata hints at money
  const v = String(el.value || "").trim();
  if (v && NUMLIKE.test(v)) return true;
  const meta = `${el.placeholder || ""} ${el.name || ""} ${el.id || ""} ${el.getAttribute("data-testid") || ""}`;
  if (MONEY_HINT.test(meta)) return true;
  // Empty text field + no meta hint → skip (don't hijack notes/name/search)
  return false;
}
